var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriorityIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_189_342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5 85C65.9721 85 85 65.9721 85 42.5C85 19.0279 65.9721 0 42.5 0C19.0279 0 0 19.0279 0 42.5C0 65.9721 19.0279 85 42.5 85Z",
    fill: "#C2001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9996 42.5C84.9996 40.0686 84.7925 37.6856 84.4003 35.3657L61.3889 12.0918L56.6668 32.5785L52.1281 37.0385L29.5139 14.1667L25.8055 44.5034L16.5504 51.1812L17.0941 66.7602L34.5976 84.2636C37.1586 84.7452 39.7992 85.0001 42.4998 85.0001C65.9719 85.0001 84.9996 65.972 84.9996 42.5Z",
    fill: "#940030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1529 70.9766C19.2625 70.9766 12.8431 64.5573 12.8431 56.6669C12.8431 48.7765 19.2625 42.3572 27.1529 42.3572C35.0432 42.3572 41.4626 48.7765 41.4626 56.6669C41.4626 64.5573 35.0432 70.9766 27.1529 70.9766ZM27.1529 46.9362C21.7872 46.9362 17.4222 51.3013 17.4222 56.6669C17.4222 62.0325 21.7872 66.3976 27.1529 66.3976C32.5185 66.3976 36.8835 62.0325 36.8835 56.6669C36.8835 51.3013 32.5183 46.9362 27.1529 46.9362Z",
    fill: "#FFEDB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1529 42.3569C27.1328 42.3569 27.1133 42.3584 27.0933 42.3584V46.9375C27.1133 46.9375 27.1328 46.936 27.1529 46.936C32.5185 46.936 36.8835 51.301 36.8835 56.6667C36.8835 62.0323 32.5185 66.3973 27.1529 66.3973C27.1328 66.3973 27.1133 66.3958 27.0933 66.3958V70.9749C27.1133 70.9749 27.1328 70.9764 27.1529 70.9764C35.0433 70.9764 41.4626 64.557 41.4626 56.6667C41.4626 48.7763 35.0433 42.3569 27.1529 42.3569Z",
    fill: "#FEE187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2423 59.3855C51.3519 59.3855 44.9326 52.9662 44.9326 45.0758C44.9326 37.1854 51.3519 30.7661 59.2423 30.7661C67.1327 30.7661 73.552 37.1854 73.552 45.0758C73.552 52.9662 67.1329 59.3855 59.2423 59.3855ZM59.2423 35.3452C53.8767 35.3452 49.5117 39.7102 49.5117 45.0758C49.5117 50.4415 53.8767 54.8065 59.2423 54.8065C64.608 54.8065 68.973 50.4415 68.973 45.0758C68.973 39.7102 64.608 35.3452 59.2423 35.3452Z",
    fill: "#FFEDB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2423 30.7661C59.1625 30.7661 59.0835 30.7709 59.0039 30.7721V35.3511C59.0835 35.3491 59.1625 35.3452 59.2423 35.3452C64.608 35.3452 68.973 39.7102 68.973 45.0758C68.973 50.4415 64.608 54.8065 59.2423 54.8065C59.1625 54.8065 59.0835 54.8025 59.0039 54.8005V59.3796C59.0835 59.3807 59.1625 59.3855 59.2423 59.3855C67.1327 59.3855 73.5521 52.9662 73.5521 45.0758C73.5521 37.1854 67.1329 30.7661 59.2423 30.7661Z",
    fill: "#FEE187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5124 14.1665H24.7903V47.222H29.5124V14.1665Z",
    fill: "#FFC61B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5148 14.1665H27.0941V47.222H29.5148V14.1665Z",
    fill: "#D48B07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3888 12.0918H56.6666V35.7029H61.3888V12.0918Z",
    fill: "#FFC61B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3898 12.0918H59.0049V35.7029H61.3898V12.0918Z",
    fill: "#D48B07"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_189_342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityIcon1);
export default __webpack_public_path__ + "static/media/priority_icon_1.74a7ad3a79dc7e9dea0402cdcbf5e13d.svg";
export { ForwardRef as ReactComponent };